import styled from 'styled-components';

import { Button } from 'components/Button';

const Create = styled(Button)`
  width: fit-content;
  margin: 2rem 0;
`;

const CreateWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;
export { Create, CreateWrapper };
